import { Reducer } from '@reduxjs/toolkit'

import { RootState } from '../../store'
import {
  GET_ESTABLISHMENT_LOADING,
  GET_ESTABLISHMENT_SUCCESS,
  GET_ESTABLISHMENT_FAILURE,
  TActionTypes,
} from '../interface/actionTypes'
import { IEstablishment } from '../interface/IEstablishment'

export interface IEstablishmentState {
  loading: boolean
  error: string
  active: IEstablishment | null
}

const initialState: IEstablishmentState = {
  loading: false,
  error: '',
  active: null,
}

export const establishmentReducer: Reducer<
  IEstablishmentState,
  TActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GET_ESTABLISHMENT_LOADING:
      return {
        ...state,
        loading: true,
      }
    case GET_ESTABLISHMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        active: action.payload.establishment,
      }
    case GET_ESTABLISHMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      }
    default:
      return state
  }
}

export const activeEstablishmentSelector = (
  state: RootState,
): IEstablishment => {
  if (!state.establishment.active) {
    throw new Error('There is no establishment')
  }
  return state.establishment.active
}
